<!--
  nav-link-expanded
  is the content that opens when a first level navigation link is selected
-->

<template>
  <transition name="slide-left">
    <div v-if="expanded" :class="{ active: expanded }" ref="linkExpanded">
      <slot />
    </div>
  </transition>
</template>

<script>
import eventBus from '@/js/util/eventBus'

export default {
  data() {
    return {
      expanded: false,
    }
  },
  props: {
    data: {
      type: String,
    },
  },
  computed: {
    getContentData: function() {
      return JSON.parse(this.data)
    },
  },
  methods: {
    expandMaybe(linkExpanded) {
      this.expanded = linkExpanded

      if (this.expanded) {
        eventBus.$emit('nav:layer2:expanded', false) // t/f are reversed here for the toggleMenu function in NavMobileDrawer
        this.$nextTick(function() {
          eventBus.$emit('select:menu:first')
        })
      } else {
        eventBus.$emit('nav:layer2:expanded', true)
      }
    },
    menuToggled(expanded) {
      if (!expanded) {
        this.expanded = false
      }
    },
  },
  mounted() {
    eventBus.$on('nav:link:' + this.getContentData.id, this.expandMaybe)
    eventBus.$on('toggle:menu', this.menuToggled)
  },
}
</script>

<style lang="scss" scoped>
.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.25s ease-in;
}

.slide-left-enter,
.slide-left-leave-to {
  transform: translateX(25px);
  opacity: 0;
}
</style>
